export default __webpack_public_path__ + "static/media/38_mobile.addfcf7c.jpeg";